<template>
  <NavButton
    v-if="showMap"
    :btn-id="button.id"
    :image-src="button.src"
    :link="button.to"
    :label="button.name"
    :list="list"
  />
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import bubblesDefault from '@/assets/imgs/bubbles.png'
import mapDefault from '@/assets/imgs/map.png'
import NavButton from '@/components/public/NavButtons/NavButton.vue'
import { VIEW_MAP, VIEW_PROJECTS } from '@/constants'

const components = {
  NavButton,
}

const props = {
  list: Boolean,
}

@Component({ components })
export default class NavBtnBubblesMap extends Vue.extend({ props }) {
  bubblesDefault = bubblesDefault
  mapDefault = mapDefault

  get bubblesName () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.navigation.bubblesName
  }

  get mapName () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.navigation.mapName
  }

  get bubblesImg () {
    const image = this.$typedStore.activeVisualisation.visualisationStore.entities.images.imageOrPreview(['config', 'navigation', 'bubblesIcon'])
    return image || bubblesDefault
  }

  get mapImg () {
    const image = this.$typedStore.activeVisualisation.visualisationStore.entities.images.imageOrPreview(['config', 'navigation', 'mapIcon'])
    return image || mapDefault
  }

  get mapShowing () {
    return this.$typedStore.public.display.mapShowing
  }

  get button () {
    if (this.mapShowing) {
      return { id: 'bubblesBtn', src: this.bubblesImg, to: { params: { mainpanel: VIEW_PROJECTS } }, name: this.bubblesName }
    } else {
      return { id: 'mapBtn', src: this.mapImg, to: { params: { mainpanel: VIEW_MAP } }, name: this.mapName }
    }
  }

  get showMap () {
    return this.$typedStore.visualisationApp.showMap
  }
}

</script>
